export default "__VITE_ASSET__WOe0iO$A__"